import { StyleSheet } from 'react-native';

import { C } from '../../common';
import { LAYOUT, THEME, ENV } from '../../reactor/common';

const {
  PAGE_OFFSET, PAGE_OFFSET_HORIZONTAL,
  PAGE_TYPE: {
    CONTENT, CHAPTER, FOOTER, GALLERY, MEDIA, SLIDER, TITLE,
  },
} = C;
const { IS_SERVER } = ENV;
const TYPES = [CONTENT, GALLERY];

const paddingBottom = ({ background: { color, image } = {}, type, nextPage }) => {
  let value = type === CHAPTER ? PAGE_OFFSET_HORIZONTAL : PAGE_OFFSET;

  if (nextPage && !image) {
    const { background = {} } = nextPage;
    if (TYPES.includes(type) && TYPES.includes(nextPage.type)
      && !background.image && color === background.color) value = 0;
  }

  return value;
};

export default {
  ...StyleSheet.create({
    background: {
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      opacity: 0.8,
      zIndex: 0,
    },
  }),

  container: (data) => {
    const { type, background: { color, image } = {} } = data;
    const { VIEWPORT: { H, PORTRAIT } } = LAYOUT;

    let paddingHorizontal = ![TITLE, SLIDER, MEDIA].includes(type) // eslint-disable-line
      ? (PORTRAIT ? PAGE_OFFSET : PAGE_OFFSET_HORIZONTAL)
      : undefined;
    if (type === GALLERY && PORTRAIT) paddingHorizontal = 0;
    const unknownHeight = [CHAPTER, CONTENT, GALLERY].includes(type);

    return {
      overflow: image
        ? 'hidden'
        : undefined,
      backgroundColor: color || THEME.COLOR.WHITE,
      height: unknownHeight // eslint-disable-line
        ? undefined
        : IS_SERVER ? '100vh' : H,
      paddingHorizontal,
      paddingBottom: unknownHeight
        ? paddingBottom(data)
        : undefined,
      paddingTop: unknownHeight // eslint-disable-line
        ? type === CHAPTER ? PAGE_OFFSET_HORIZONTAL : PAGE_OFFSET
        : undefined,
      zIndex: [TITLE, FOOTER].includes(type) // eslint-disable-line
        ? type === TITLE ? 1 : -1
        : undefined,
    };
  },
};
